import React from "react";
import { CardColor } from "../types/game";

type NonWildColor = Exclude<CardColor, CardColor.WILD>;

interface ColorPickerProps {
  onSelect: (color: NonWildColor) => void;
  onCancel: () => void;
}

export function ColorPicker({ onSelect, onCancel }: ColorPickerProps) {
  const colors: NonWildColor[] = [CardColor.RED, CardColor.BLUE, CardColor.GREEN, CardColor.YELLOW];

  return (
    <div style={styles.overlay}>
      <div style={styles.picker}>
        <h3 style={styles.title}>Choose a color:</h3>
        <div style={styles.colors}>
          {colors.map((color) => (
            <button
              key={color}
              onClick={() => onSelect(color)}
              style={{
                ...styles.colorButton,
                background: getColorHex(color),
              }}
            >
              {color.charAt(0).toUpperCase() + color.slice(1)}
            </button>
          ))}
        </div>
        <button onClick={onCancel} style={styles.cancelButton}>
          Cancel
        </button>
      </div>
    </div>
  );
}

function getColorHex(color: CardColor): string {
  // Use CSS variables for card colors
  const root = document.documentElement;
  const colorMap: Record<CardColor, string> = {
    [CardColor.RED]: "--card-red",
    [CardColor.BLUE]: "--card-blue",
    [CardColor.GREEN]: "--card-green",
    [CardColor.YELLOW]: "--card-yellow",
    [CardColor.WILD]: "#333",
  };
  const cssVar = colorMap[color];
  if (cssVar && cssVar.startsWith("--")) {
    return getComputedStyle(root).getPropertyValue(cssVar).trim() || "#95a5a6";
  }
  return cssVar || "#95a5a6";
}

const styles: Record<string, React.CSSProperties> = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: "var(--bg-overlay)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
  },
  picker: {
    background: "var(--bg-card)",
    // backdropFilter removed for Casual Party (solid backgrounds, no blur)
    borderRadius: "16px",
    padding: "30px",
    boxShadow: "0 20px 60px rgba(0,0,0,0.15)",
    border: "1px solid var(--border-subtle)",
  },
  title: {
    margin: "0 0 20px 0",
    textAlign: "center",
    color: "var(--text)",
  },
  colors: {
    display: "flex",
    gap: "15px",
    marginBottom: "20px",
  },
  colorButton: {
    width: "80px",
    height: "80px",
    border: "none",
    borderRadius: "8px",
    color: "white",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "transform 0.2s",
  },
  cancelButton: {
    width: "100%",
    padding: "10px",
    background: "var(--bg-card-hover)",
    border: "1px solid var(--border-medium)",
    borderRadius: "8px",
    cursor: "pointer",
    fontSize: "16px",
    color: "var(--text)",
  },
};
